<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">后台账号</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">医生名称：{{edit_name}}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" class="item">
            <el-tree
                :data="listStaffAll"
                show-checkbox
                default-expand-all
                node-key="staffCode"
                ref="tree"
                highlight-current
                :props="defaultProps">
            </el-tree>
          </el-col>
        </el-row>


      </div>

      <div class="modal-footer">
        <el-button type="primary" @click="confirm()">确定</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'EditStaff',
  data() {
    return {

      edit_medicinerCode:'',
      edit_name:'',
      edit_listMedicinerStaffRel:[],

      listStaffAll:null,
      defaultProps: {
        children: 'listStaffAll',
        label: 'loginName'
      },


    }
  },

  methods: {
    init(row){

      this.edit_medicinerCode = row.medicinerCode;
      this.edit_name = row.name;
      this.edit_listMedicinerStaffRel = row.listMedicinerStaffRelDTO;

      this.getListStaff();

    },

    closeSelf() {
      this.$emit("closeEditStaff");
    },


    getListStaff(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Staff/ListForMediciner2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          medicinerCode: this.edit_medicinerCode,
        }
      }).then((response) => {
        //console.log(response);

        if (response.data.error == 0) {
          this.listStaffAll = response.data.data;
          this.checkedNode(this.edit_listMedicinerStaffRel);
        }

      })

    },


    checkedNode(listSonInstitutionRelDTO){
      let getArr = [];
      for(let i=0;i<listSonInstitutionRelDTO.length;i++){
        getArr.push(listSonInstitutionRelDTO[i].staffCode);
      }
      this.$nextTick(function(){
        this.$refs.tree.setCheckedKeys(getArr);
      })
    },


    confirm(){

      let nodes = this.$refs.tree.getCheckedNodes(false,true);
      console.log(nodes);

      let arr = [];
      for(let i=0;i<nodes.length;i++){
        arr.push({"staffCode":nodes[i].staffCode});
      }


      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicinerStaffRel/Edit",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),

          listStaff: arr,
          medicinerCode:this.edit_medicinerCode,
        }
      }).then((response) => {
        //console.log(response);

        if (response.data.error == 0) {
          this.$emit("closeEditStaff");
          this.$emit("getList");
        }else {
          this.$message({type: 'info', message: '编辑失败'});
        }
      })

    },


  }
}


</script>

